{
  "excluded_types": [
    "administrative_area_level_1",
    "administrative_area_level_2",
    "administrative_area_level_3",
    "administrative_area_level_4",
    "administrative_area_level_5",
    "archipelago",
    "colloquial_area",
    "continent",
    "country",
    "floor",
    "intersection",
    "locality",
    "natural_feature",
    "neighborhood",
    "political",
    "post_box",
    "postal_code",
    "postal_code_prefix",
    "postal_code_suffix",
    "postal_town",
    "route",
    "sublocality",
    "sublocality_level_1",
    "sublocality_level_2",
    "sublocality_level_3",
    "sublocality_level_4",
    "sublocality_level_5",
    "town_square"
  ],
  "included_primary_types": ["street_address", "premise", "subpremise", "business_center"]
}
